<template>
    <div class="query-record">
        <el-card class="box-card flex-1 marginT-20">
            <div slot="header" class="flex flex-between">
                <span class="fw-bold fc-333">生成记录</span>
            </div>
            <div>
                <div class="table">
                    <el-table :data="tableData" border>
                        <!--<el-table-column prop="result_data.password" label="淘口令"></el-table-column>-->
                        <el-table-column prop="result_data.password" label="生成方式">
                            <template slot-scope="scope">
                                <span>{{scope.row.result_data.password ? '淘口令' : '二维码'}}</span>
                                <el-button style='margin-left: 6px;' type='text' v-show='!scope.row.result_data.password' @click="lookQrCode(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column v-for="(item, index) in selCol" :key="item" :prop="`result_data.${item}`" :label="index">
                            <template slot-scope="scope">
                                <el-popover v-if="index == '商品链接(商品ID)'" trigger="hover" placement="top">
                                    <p>{{ scope.row.result_data[item] || '--'}}
                                    </p>
                                    <div slot="reference"
                                        class="name-wrapper">
                                        {{ scope.row.result_data[item] || '--'}}
                                    </div>
                                </el-popover>
                                <div v-else>{{scope.row.result_data[item]}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="完成时间" :formatter="row => dateFormatUtils(row.created_at * 1000)"></el-table-column>
                    </el-table>
                </div>
                <div class="pages marginT-20 text-center">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-size="5"
                        layout="total, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import pagination from '@/index/mixin/pagination'

const tableCol = {
    default: {
        '搜索关键词': 'content',
        '商品链接(商品ID)': 'url'
    },
    foreignTao: {
        '洋淘秀ID': 'url',
    },
    mobileUrl: {
        '宝贝标题': 'content',
        '商品链接(商品ID)': 'url'
    }
}
export default {
    mixins: [pagination],
    props: {
        method: {
            type: String,
            default: '',
        },
        tableColType: {
            type: String,
            default: ''
        },
        // 手动初始化, 默认 false
        manualInit: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            selCol: {},
            searchForm: {
                invokeName: this.method,
                psize: 5,
            },
            tableData: [],
            tableUrl: '/tool/accounts/invoke-log',
        }
    },
    methods: {
        lookQrCode(row) {
            window.showQrCode(row.result_data.item_url);
        },
    },
    mounted() {
        if (localStorage.token && !this.manualInit) {
            this.init()
        }
        if (this.tableColType) {
            this.selCol = tableCol[this.tableColType] || tableCol['default']
        } else {
            this.selCol = tableCol[this.method] || tableCol['default']
        }

    },
    watch: {
        method(newValue, oldValue) {
            if (newValue) {
                this.searchForm.invokeName = newValue
            }
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
